import { ResourceAvailability } from "@app/models/rest/resource-availability";

export class AvailabilityIssue {
  availabilityId: number;
  availability: ResourceAvailability;
  issues: string[];
  normalOver: boolean = false;
  highOver: boolean = false;
  emergencyOver: boolean = false;
}
